import React from "react";
import { urls } from "src/settings/constants";
import { Link, Nav } from "./ContactLinks.style";

const ContactLinks = () => (
  <Nav>
    {urls.map((link, key) => (
      <Link key={key} href={link.url} target="_blank">
        {link.text}
      </Link>
    ))}
  </Nav>
);

export default ContactLinks;
